<template>
  <div>
    <a class="backBtn" :href="`/#/mission/${missionId}`">
      <img src="/img/back-icon.png" />
    </a>
    <div v-if="isIframe">
      <div class="background-activities" :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`" >
        <div class="sideBar"> 
          <h1>ACTIVIDADES</h1>
          <div class="list">
            <div class="button-container">
              <button class="active" @click="showCurse('Matemáticas')">MATEMÁTICAS</button>
            </div>
            <div class="button-container">
              <button @click="showCurse('Ciencias')">CIENCIAS</button>
            </div>
            <div class="button-container">
              <button v-if="missionId !== 1 && missionId !== 2" @click="showCurse('Geografía')">Geografía</button>
            </div>
            <div class="button-container">
              <button v-if="missionId !== 2"  @click="showCurse('fisica')">Educación Física</button>
            </div>
            <div class="button-container">
              <button @click="showCurse('civica')">Formación Cívica y Ética</button>
            </div>
            <div class="button-container">
              <button v-if="missionId !== 5 && missionId !== 6" @click="showCurse('habilidades')">HABILIDADES GENERALES</button>
            </div>
            <div class="button-container">
              <button @click="showCurse('comunicacion')">LENGUAJE Y COMUNICACIÓN</button>
            </div>
            <div class="button-container">
              <button v-if="missionId !== 6 && missionId !== 5" @click="showCurse('historia')">Historia</button>
            </div>
          </div>
        </div>
        <div class="container-activities">
          <template v-for="actividad, index in actividades"  >
              <!-- <button :key="index" v-if="actividad.grado === missionId && actividad.asignatura === isAsignatura" @click="showIframe(actividad.url)">{{actividad.tema}}</button> -->
              <a :key="index" v-if="actividad.grado === missionId && actividad.asignatura === isAsignatura" :href="`/#/mission/${missionId}/actividad/${actividad.url}`" >{{actividad.tema}}</a>
          </template>
        </div>
      </div>
    </div>
    <div class="screen-container-book" :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`" v-else>
      <iframe :src="`https://www.mdt.mx/KrismarApps/index.php/recurso/cargarApp/${iframeId}/primaria`" frameborder="0" width="100%" height="100%" style="border: none" id="book"></iframe>
    </div>
  </div>
</template>
<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';
import Button from '../components/Button.vue';

export default {
  components: { Button },
  name: 'Actividad',
  created() {
    this.init();
    NProgress.done();
  },
  computed: {
    missionId () {
      return parseInt(this.$route.params.missionId);
    }
  },
  data () {
    return {
      isIframe: true,
      iframeId: '',
      isAsignatura: 'Matemáticas',
      actividades: [
                    {
                      "grado": 2,
                      "asignatura": "Ciencias",
                      "tema": "La importancia de la comida saludable",
                      "tipo": "Animación",
                      "url": "931",
                    },
                    {
                      "grado": 2,
                      "asignatura": "Ciencias",
                      "tema": "¿Con qué sentido se disfruta?",
                      "tipo": "Interactiva",
                      "url": "2434",
                    },
                    {
                      "grado":2,
                      "asignatura": "Ciencias",
                      "tema": "Clasifica la basura",  	
                      "tipo": "Interactiva",	
                      "url": "2929",
                    },
                    {
                      "grado":2,
                      "asignatura": "civica",
                      "tema": "¡Salud!",
                      "tipo": "Animación",
                      "url": "976",
                    },
                    {
                      "grado":2,
                      "asignatura": "civica",
                      "tema": "La cooperación y el compañerismo",
                      "tipo": "Interactiva",	
                      "url": "7964",
                    },
                    {
                      "grado":2,
                      "asignatura": "habilidades",
                      "tema": "Descubre la frase",
                      "tipo": "Interactiva",	
                      "url": "1690",
                    },
                    {
                      "grado":2,
                      "asignatura": "comunicacion",
                      "tema": "Sinónimos",
                      "tipo": "Interactiva",	
                      "url": "7930",
                    },
                    {
                      "grado":2,
                      "asignatura": "comunicacion",
                      "tema": "Adjetivo calificativo",
                      "tipo": "Interactiva",	
                      "url": "96",
                    },
                    {
                      "grado":2,
                      "asignatura": "comunicacion",
                      "tema": "Fábulas",
                      "tipo": "Animación",
                      "url": "323",
                    },
                    {
                      "grado":2,
                      "asignatura": "comunicacion",
                      "tema": "Completa la frase con sustantivos",
                      "tipo": "Interactiva",	
                      "url": "6654",
                    },
                    {
                      "grado":2,
                      "asignatura": "comunicacion",
                      "tema": "Completa las rimas",
                      "tipo": "Interactiva",	
                      "url": "7129",
                    },
                    {
                      "grado":2,
                      "asignatura": "comunicacion",
                      "tema": "Ordena las frase",
                      "tipo": "Interactiva",	
                      "url": "1924",
                    },
                    {
                      "grado":2,
                      "asignatura": "comunicacion",
                      "tema": "Sílabas para 2º",
                      "tipo": "Interactiva",	
                      "url": "1693",
                    },
                    {
                      "grado":2,
                      "asignatura": "Matemáticas",
                      "tema": "Contar en grupos de 5",
                      "tipo": "Interactiva",	
                      "url": "2989",
                    },
                    {
                      "grado":2,
                      "asignatura": "Matemáticas",
                      "tema": "Sumar y restar/¿Quién llega más lejos?",
                      "tipo": "Interactiva",	
                      "url": "4226",
                    },
                    {
                      "grado":2,
                      "asignatura": "Matemáticas",
                      "tema": "Dinero/¿Cuánto gasté?",
                      "tipo": "Interactiva",	
                      "url": "3003",
                    },
                    {
                      "grado":2,
                      "asignatura": "Matemáticas",
                      "tema": "¡A calcular fechas!",
                      "tipo": "Interactiva",	
                      "url": "1401",
                    },
                    {
                      "grado":2,
                      "asignatura": "Matemáticas",
                      "tema": "¿Cómo lo doblo?",
                      "tipo": "Interactiva",	
                      "url": "470",
                    },
                    {
                      "grado":2,
                      "asignatura": "Matemáticas",
                      "tema": "Construcción de cuerpos geométricos",
                      "tipo": "Interactiva",	
                      "url": "3071",
                    },
                    {
                      "grado":2,
                      "asignatura": "Matemáticas",
                      "tema": "Centenas, decenas y unidades (millares)",
                      "tipo": "Interactiva",	
                      "url": "283",
                    },
                    {
                      "grado":1, 
                      "asignatura": "habilidades",
                      "tema": "Encuentra las diferencias",	
                      "tipo": "Interactiva",
                      "url": "3085"
                    },
                    {
                      "grado":1, 
                      "asignatura": "habilidades",
                      "tema": "Series",
                      "tipo": "Interactiva",
                      "url": "1708"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Matemáticas",
                      "tema": "Figuras iguales/hacer figuras con el tangram	",
                      "tipo": "Interactiva",
                      "url": "4780"
                    },
                    {
                      "grado":1, 
                      "asignatura": "fisica",
                      "tema": "Actividad física	",
                      "tipo": "Animación",
                      "url": "7089"
                    },
                    {
                      "grado":1, 
                      "asignatura": "habilidades",
                      "tema": "Cuál imagen no está repetida	",
                      "tipo": "Interactiva",
                      "url": "2431"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Matemáticas",
                      "tema": "Monedas en uso	",
                      "tipo": "Interactiva",
                      "url": "3162"
                    },
                    {
                      "grado":1, 
                      "asignatura": "comunicacion",
                      "tema": "Diviértete con el abecedario",	
                      "tipo": "Interactiva",
                      "url": "6967"
                    },
                    {
                      "grado":1, 
                      "asignatura": "comunicacion",
                      "tema": "El cuento",
                      "tipo": "Animación",
                      "url": "7810"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Ciencias",
                      "tema": "Ubicación en croquis	",
                      "tipo": "Interactiva",
                      "url": "2966"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Ciencias",
                      "tema": "Agrupa a los animales	",
                      "tipo": "Interactiva",
                      "url": "2957"
                    },
                    {
                      "grado":1, 
                      "asignatura": "civica",
                      "tema": "Acepta a la gente como es	",
                      "tipo": "Animación",
                      "url": "920"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Matemáticas",
                      "tema": "Números consecutivos	",
                      "tipo": "Interactiva",
                      "url": "443"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Matemáticas",
                      "tema": "Sumando canicas",
                      "tipo": "Interactiva",
                      "url": "427"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Matemáticas",
                      "tema": "Figuras semejantes",
                      "tipo": "Interactiva",
                      "url": "127"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Matemáticas",
                      "tema": "Paga con billetes y monedas",
                      "tipo": "Interactiva",
                      "url": "3165"
                    },
                    {
                      "grado":1, 
                      "asignatura": "Matemáticas",
                      "tema": "Leo y escribo números",
                      "tipo": "Interactiva",
                      "url": "2971"
                    },
                    {
                      "grado":1, 
                      "asignatura": "comunicacion",
                      "tema": "Reglamento",
                      "tipo": "Interactiva",
                      "url": "259"
                    },
                    {
                      "grado":1, 
                      "asignatura": "comunicacion",
                      "tema": "Ordenar alfabeticamente",
                      "tipo": "Interactiva",
                      "url": "7251"
                    },
                    {
                      "grado":1, 
                      "asignatura": "comunicacion",
                      "tema": "Fichas informativas",
                      "tipo": "Interactiva",
                      "url": "262"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "comunicacion",
                      "tema": "Sinónimos",
                      "tipo": "Interactiva",
                      "url": "7921"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Matemáticas",
                      "tema": "La papelería/problemas de suma",
                      "tipo": "Interactiva",
                      "url": "3106"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "fisica",
                      "tema": "Qué es la gimnasia",	
                      "tipo": "Animación",
                      "url": "7493"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "fisica",
                      "tema": "¿Qué competencias hay en natación?",
                      "tipo": "Animación",
                      "url": "7498"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Matemáticas",
                      "tema": "Redondear a decenas	",
                      "tipo": "Interactiva",
                      "url": "445"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Matemáticas",
                      "tema": "Centenas, decenas y unidades	",
                      "tipo": "Interactiva",
                      "url": "282"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Matemáticas",
                      "tema": "Grupos para multiplicar	",
                      "tipo": "Interactiva",
                      "url": "333"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Ciencias",
                      "tema": "Nutrición	",
                      "tipo": "Animación",
                      "url": "5034"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Ciencias",
                      "tema": "Sistemas del cuerpo humano",	
                      "tipo": "Interactiva",
                      "url": "6369"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "civica",
                      "tema": "Justicia	",
                      "tipo": "Interactiva",
                      "url": "7867"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "civica",
                      "tema": "Equidad de género	",
                      "tipo": "Interactiva",
                      "url": "8314"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "comunicacion",
                      "tema": "Adivinanzas	",
                      "tipo": "Interactiva",
                      "url": "93"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "comunicacion",
                      "tema": "Sílabas	",
                      "tipo": "Interactiva",
                      "url": "7396"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "habilidades",
                      "tema": "Discriminación",	
                      "tipo": "Interactiva",
                      "url": "7252"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "habilidades",
                      "tema": "Memorama	",
                      "tipo": "Interactiva",
                      "url": "7391"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Geografía",
                      "tema": "Mapa de México	",
                      "tipo": "Interactiva",
                      "url": "5012"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Geografía",
                      "tema": "Qué es una península	",
                      "tipo": "Animación",
                      "url": "1641"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "Matemáticas",
                      "tema": "Identifica la fracción	",
                      "tipo": "Interactiva",
                      "url": "390"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "comunicacion",
                      "tema": "Ortografía con las letras C, S, Z",	
                      "tipo": "Interactiva",
                      "url": "1929"
                    },
                    {
                      "grado": 3, 
                      "asignatura": "comunicacion",
                      "tema": "Relaciona la causa con su consecuencia	",
                      "tipo": "Interactiva",
                      "url": "2248"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "comunicacion",
                      "tema": "Mecanografía/Manos	",
                      "tipo": "Interactiva",
                      "url": "8255"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "fisica",
                      "tema": "¿Qué son los juegos olímpicos?	",
                      "tipo": "Animación",
                      "url": "7496"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Matemáticas",
                      "tema": "Completa la centena (4 cifras)	",
                      "tipo": "Interactiva",
                      "url": "110"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Matemáticas",
                      "tema": "¿Cuál figura tiene mayor perímetro o área?	",
                      "tipo": "Interactiva",
                      "url": "3072"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "civica",
                      "tema": "Respeto	",
                      "tipo": "Interactiva",
                      "url": "7959"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "civica",
                      "tema": "Garantías individuales	",
                      "tipo": "Interactiva",
                      "url": "8424"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "historia",
                      "tema": "Mapa de Mesoamérica",
                      "tipo": "Interactiva",
                      "url": "1249"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "historia",
                      "tema": "Mesoamérica	",
                      "tipo": "Interactiva",
                      "url": "1227"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "habilidades",
                      "tema": "Analogías	",
                      "tipo": "Interactiva",
                      "url": "7422"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "habilidades",
                      "tema": "Antónimos	",
                      "tipo": "Interactiva",
                      "url": "7551"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "comunicacion",
                      "tema": "Tipos de texto	",
                      "tipo": "Interactiva",
                      "url": "7750"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "comunicacion",
                      "tema": "Acentos	",
                      "tipo": "Interactiva",
                      "url": "6709"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Ciencias",
                      "tema": "Cuerpo humano",	
                      "tipo": "Interactiva",
                      "url": "6762"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Ciencias",
                      "tema": "Sistema respiratorio	",
                      "tipo": "Interactiva",
                      "url": "895"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Geografía",
                      "tema": "Topografía	",
                      "tipo": "Interactiva",
                      "url": "530"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Geografía",
                      "tema": "Regiones naturales	",
                      "tipo": "Interactiva",
                      "url": "5030"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Matemáticas",
                      "tema": "¡Gana en la lotería de divisiones!	",
                      "tipo": "Interactiva",
                      "url": "2965"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Matemáticas",
                      "tema": "¿Qué fracción representa el color?	",
                      "tipo": "Interactiva",
                      "url": "660"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "Matemáticas",
                      "tema": "Sin cortes	",
                      "tipo": "Interactiva",
                      "url": "1677"
                    },
                    {
                      "grado": 4, 
                      "asignatura": "comunicacion",
                      "tema": "Interpretación de refranes"	,
                      "tipo": "Interactiva",
                      "url": "6860"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Matemáticas",
                      "tema": "ESS	Potencias 	",
                      "tipo": "Interactiva",
                      "url": "3209"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "comunicacion",
                      "tema": "Mecanografía	",
                      "tipo": "Interactiva",
                      "url": "8255"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "historia",
                      "tema": "México despues de la independencia	",
                      "tipo": "Interactiva",
                      "url": "558"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "historia",
                      "tema": "Economía 1827-1847	",
                      "tipo": "Interactiva",
                      "url": "565"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Geografía",
                      "tema": "Mapas, croquis y planos	",
                      "tipo": "Interactiva",
                      "url": "5017"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Geografía",
                      "tema": "Continentes y sus colindancias	",
                      "tipo": "Interactiva",
                      "url": "529"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Geografía",
                      "tema": "Actividades económicas	",
                      "tipo": "Interactiva",
                      "url": "6563"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Ciencias",
                      "tema": "Plato del buen comer	",
                      "tipo": "Interactiva",
                      "url": "677"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Ciencias",
                      "tema": "Aparato digestivo	",
                      "tipo": "Interactiva",
                      "url": "562"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "civica",
                      "tema": "Acuerdos para la convivencia	",
                      "tipo": "Interactiva",
                      "url": "8459"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "civica",
                      "tema": "Características de la democracia	",
                      "tipo": "Interactiva",
                      "url": "8494"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "comunicacion",
                      "tema": "Palabras con B y V	",
                      "tipo": "Interactiva",
                      "url": "6840"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "comunicacion",
                      "tema": "Guion de teatro	",
                      "tipo": "Interactiva",
                      "url": "105"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "fisica",
                      "tema": "Teoría del baloncesto	",
                      "tipo": "Animación",
                      "url": "4950"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Matemáticas",
                      "tema": "Ubicación espacial de cuerpos geométricos	",
                      "tipo": "Interactiva",
                      "url": "2964"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Matemáticas",
                      "tema": "Fracción de una unidad	",
                      "tipo": "Interactiva",
                      "url": "745"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Matemáticas",
                      "tema": "Manejo de porcentajes	",
                      "tipo": "Interactiva",
                      "url": "135"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "Matemáticas",
                      "tema": "Perímetro y área de cuadriláteros	",
                      "tipo": "Interactiva",
                      "url": "136"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "comunicacion",
                      "tema": "Cuadros sinópticos, poemas y debate	",
                      "tipo": "Interactiva",
                      "url": "8185"
                    },
                    {
                      "grado": 5, 
                      "asignatura": "comunicacion",
                      "tema": "Acentos, (N2)	",
                      "tipo": "Interactiva",
                      "url": "7739"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "historia",
                      "tema": "Civilizaciones antiguas	",
                      "tipo": "Interactiva",
                      "url": "803"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "historia",
                      "tema": "Prehistoria	",
                      "tipo": "Interactiva",
                      "url": "809"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Geografía",
                      "tema": "Localización por coordenadas	",
                      "tipo": "Interactiva",
                      "url": "774"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Geografía",
                      "tema": "Migración	",
                      "tipo": "Interactiva",
                      "url": "760"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Ciencias",
                      "tema": "Máquinas simples	",
                      "tipo": "Interactiva",
                      "url": "1273"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Ciencias",
                      "tema": "Sistemas del cuerpo humano	",
                      "tipo": "Interactiva",
                      "url": "5082"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "civica",
                      "tema": "Derechos Humanos	",
                      "tipo": "Interactiva",
                      "url": "8500"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "civica",
                      "tema": "Dilemas en la vida cotidiana	",
                      "tipo": "Interactiva",
                      "url": "8493"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "comunicacion",
                      "tema": "Adjetivos	",
                      "tipo": "Interactiva",
                      "url": "582"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "comunicacion",
                      "tema": "Pretérito, copretérito, pospretérito	",
                      "tipo": "Interactiva",
                      "url": "7747"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "fisica",
                      "tema": "Atletismo",	
                      "tipo": "Animación",
                      "url": "7485"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Matemáticas",
                      "tema": "Plano cartesiano	",
                      "tipo": "Interactiva",
                      "url": "1220"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Matemáticas",
                      "tema": "Razones/¿Cuál es el mejor precio?	",
                      "tipo": "Interactiva",
                      "url": "1495"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Matemáticas",
                      "tema": "Equivalencia de fracciones nivel 5	",
                      "tipo": "Interactiva",
                      "url": "174"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Matemáticas",
                      "tema": "Calcula la probabilida de...	",
                      "tipo": "Interactiva",
                      "url": "1494"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Matemáticas",
                      "tema": "Vamos a balancer (N2)	",
                      "tipo": "Interactiva",
                      "url": "2360"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "Matemáticas",
                      "tema": "Hunde el submarino [plano cartesiano]	",
                      "tipo": "Interactiva",
                      "url": "1220"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "comunicacion",
                      "tema": "Guion de teatro",	
                      "tipo": "Interactiva",
                      "url": "105"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "comunicacion",
                      "tema": "¿Qué tipo de texto es?	",
                      "tipo": "Interactiva",
                      "url": "7750"
                    },
                    {
                      "grado": 6, 
                      "asignatura": "comunicacion",
                      "tema": "Preposiciones	",
                      "tipo": "Interactiva",
                      "url": "7753"
                    },
      ]
    };
  },
  methods: {
    init() {
      // frames['iframe1'].window.document.head.appendChild('hola');
      // let myiFrame = document.getElementById("exercise");
      // let doc = myiFrame.contentDocument;
      // doc.body.innerHTML = doc.body.innerHTML + '<style> .divOverlay{ background: none}</style>';
      // document.getElementById('iframe_id').contentWindow.document.body.innerHTML = 
      // var iframe = document.getElementById('iframe_id')
      // var style = document.createElement('style')
      // style.textContent =
      //     'body {' +
      //     '  background-color: lime;' +
      //     '  color: pink;' +
      //     '}'
      // ;
      // iframe.contentDocument.head.appendChild(style)
    },
    logout() {
      Auth.logout();
    },
    showCurse(asignatura) {
      this.isAsignatura = asignatura;
    },
    showIframe(id) {
      this.isIframe = false;
      this.iframeId = id;
      debugger
      var iframe = document.getElementById('book')
      var css = document.createElement('style');
      css.type = 'text/css';
      var styles = 'body {' +
          '  background-color: lime;' +
          '  color: pink;' +
      '}';
      css.appendChild(document.createTextNode(styles));
      console.log(iframe)
      iframe.contentWindow.document.head.appendChild(css);
    }
  },
}
</script>
<style lang="scss">
 .container-activities {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: inherit;
  max-height: calc(100vh - 20px);
  overflow-y: auto;
  height: 100%;
  top: 0;
  margin-top: 63px;
  display: grid;
  grid-template-columns: calc(50% - 5px) calc(50% - 5px);
  grid-template-rows: auto;
  overflow-y: auto;
  border: 2px solid #98d3fd;
  background: #20455fab;
  column-gap: 10px;
  row-gap: 10px;
  padding: 10px;
  a {
    text-decoration: none;
    line-height: 1.6em;
    font-size: 2em;
    padding: 12px 17px;
    display: block;
    color: white;
    font-family: 'Montserrat';
    font-weight: 900;
    transition: all 0.9s ease-in;
    border-right: 2px solid #98d3fd!important;
    border-bottom: 2px solid #98d3fd !important;
    border: 2px transparent;
    background: #20455fab;
    &:hover {
      background: #6b94b1;
      color: #fff;
      cursor: selector;
      cursor: pointer;
      transition: 3;
      transition: all 0.5s ease-out;
    }
  }
  .tab-trim {
    display: flex;
    padding: 9px;
    button {
      background: #040403c9;
      margin: 0 5px;
      text-shadow: 1.5px 1px #070704a1;
      border: 1px solid white;
    }
    button:hover {
      background: #98d3fd;
    }
    .active {
      background: #98d3fd;
    }
  }
  h2 {
     button {
       background-color: #98d3fd52;
      /* border: 2px solid #98d3fd; */
      border-radius: 4px;
      cursor: pointer;
     }
  }
}
</style>